import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // DatePicker 컴포넌트의 스타일을 import합니다.
import ko from "date-fns/locale/ko";
import { StyledDatePicker } from "./style";
import { IconImg } from "../../contents/Icons";

export const DateRangePicker = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  return (
    <StyledDatePicker>
      <div className="date-picker">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="조회시작일"
          showIcon
          icon={<IconImg.Calendar />}
          locale={ko}
          minDate={new Date("2023-01-01")}
          maxDate={endDate}
        />
        <p>~</p>
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="조회종료일"
          showIcon
          icon={<IconImg.Calendar />}
          locale={ko}
          minDate={startDate}
          maxDate={new Date()}
        ></DatePicker>
      </div>
    </StyledDatePicker>
  );
};
